import { ModalContextProvider } from 'utils/contexts/modal/provider';
import { TemplateDiffContextProvider } from '../context/TemplateDiffContextProvider';
import { TemplateDiff } from './TemplateDiff';

export const TemplateDiffPage = () => {
  return (
    <ModalContextProvider>
      <TemplateDiffContextProvider>
        <TemplateDiff />
      </TemplateDiffContextProvider>
    </ModalContextProvider>
  );
};
